<div class="content">
    <div class="card m-5">

        <div class="card-body">
            <h4 class="card-title">Sign In</h4>
            <div *ngIf="showErrMsg" class="err-msg" [innerHtml]="errMessage"></div>
            <form class="form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="form-group m-3">
                    <input autocomplete="off" type="email" class="form-control" id="email" aria-describedby="emailHelp"
                        placeholder="Enter Email" formControlName="emailAddress"
                        [class.invalid]="(loginFormControl['emailAddress'].valid || submitted) && loginFormControl.emailAddress.errors?.required">
                    <span class="text-danger"
                        *ngIf="(loginFormControl['emailAddress']?.valid || submitted) && loginFormControl['emailAddress'].hasError('required')">
                        Email is required
                    </span>
                    <span class="text-danger"
                        *ngIf="(loginFormControl['emailAddress'].invalid && (loginFormControl['emailAddress'].errors.email && loginFormControl['emailAddress'].errors.pattern))">
                        Enter a valid email address
                    </span>

                </div>

                <div class="form-group m-3">
                    <input type="password" class="form-control" id="password" formControlName="password"
                        placeholder="Enter Password"
                        [class.invalid]="(loginFormControl['password'].valid || submitted) && loginFormControl.password.errors?.required">

                    <span class="text-danger"
                        *ngIf="(loginFormControl['password']?.valid || submitted) && loginFormControl['password'].hasError('required')">
                        Password is required
                    </span>
                    <span class="text-danger"
                        *ngIf="loginFormControl['password'].invalid && (loginFormControl['password'].errors.minlength || loginFormControl['password'].errors.maxLength)">
                        Password must between 6 to 30 charactes long
                    </span>
                </div>
                <!-- <div class="form-check m-3 check-input">
                    <input type="checkbox" class="form-check-input" id="exampleCheck1">
                    <label class="form-check-label" for="exampleCheck1">Remember Me</label>
                </div> -->


                <div class="signin-btn">
                    <button type="submit" class="btn btn-primary"
                    appTrackClick 
                    [buttonProps]="{
                    title: 'login_with_email_button',
                    feature_context: 'LOGIN'
                    }"
                    >Sign In</button>
                </div>
            </form>
            <div class="sso-border m-2">
                <hr class="sc-fTQvRK hPtQws">
                <div class="sc-ikJyIC jvLCsN">
                    <p class="sc-cxpSdN gySmEh">OR</p>
                </div>
                <hr class="sc-fTQvRK hPtQws">
            </div>
            <div class="text-center">
                <div *ngIf="firebaseLoginMethods.google" class="row sso-container">
                    <div class="col-md-12 sso-btn" (click)="googleSignIn()"
                    appTrackClick 
                    [buttonProps]="{
                    title: 'login_with_google_button',
                    feature_context: 'LOGIN'
                    }"
                    >
                        <div><img src="assets/svg/google-logo.png"></div>
                        <div class="sso-login">Continue with Google</div>
                    </div>
                </div>
                <div *ngIf="firebaseLoginMethods.facebook" class="row sso-container">
                    <div class="col-md-12 sso-btn" (click)="facebookSignIn()"
                      appTrackClick 
                    [buttonProps]="{
                        title: 'login_with_facebook_button',
                        feature_context: 'LOGIN'
                        }"
                    >
                        <div><img src="assets/svg/icons8-facebook.svg"></div>
                        <div class="sso-login">Continue with Facebook</div>
                    </div>
                </div>
                <div *ngIf="firebaseLoginMethods.apple" class="row sso-container">
                    <div class="col-md-12 sso-btn" (click)="showAppleInstructions()"
                     appTrackClick 
                    [buttonProps]="{
                        title: 'login_with_apple_button',
                        feature_context: 'LOGIN'
                        }"
                    >
                        <div><img src="assets/svg/icons8-apple-logo.svg"></div>
                        <div class="sso-login">Continue with Apple</div>
                    </div>
                </div>
            </div>

            <small class="privacy-policy m-2"> <span style="color: #f44336;margin-top: 15px;cursor: pointer;"
                    (click)="navigateToForgotPassword()" 
                    appTrackClick 
                    [buttonProps]="{
                    title: 'forgot_password_button',
                    feature_context: 'LOGIN'
                    }"
                    >Forgot Password ?</span> </small>
            <small class="privacy-policy m-2">Need an Account? &nbsp;<span class="login"
                    (click)="navigateToSignUp()"
                    appTrackClick 
                    [buttonProps]="{
                    title: 'login_page_signup_button',
                    feature_context: 'LOGIN'
                    }"
                    >Sign Up</span>
            </small>

        </div>
    </div>
</div>

<ng-template #progressDialog>
    <mat-dialog-content>
        <p style="font-size: 18px;">Logging you in please wait!</p>
    </mat-dialog-content>
    <mat-spinner [diameter]="30" [strokeWidth]="3" mode="indeterminate" style="margin: auto;"></mat-spinner>
    <!-- <mat-dialog-actions align="end">
      <button mat-button matDialogClose color="primary">Dismiss</button>
    </mat-dialog-actions> -->
</ng-template>

<ng-template #appleDialog>
    <h2 matDialogTitle>Attention!</h2>
    <mat-dialog-content>
        <p><b>Please share your Email Address with us to Sign In on the Creatics Platform.</b></p>
        <p> Please select the <b>Share My Email</b> option when asked by Apple. Click on "Continue" to proceed.</p>
        <img src="assets/images/sign-up-with-apple-instructions.jpg" class="apple-fix" alt="">
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button matDialogClose color="primary">Dismiss</button>
        <button mat-raised-button color="warn" (click)="appleSignIn()">Continue</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #errDialog>
    <h2 matDialogTitle>Sign Up Failed!</h2>
    <mat-dialog-content>
        <p style="max-width: 500px;" [innerHTML]="errMessage"></p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="warn" matDialogClose>Dismiss</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #appleErrDialog>
    <h2 matDialogTitle>Sign Up Failed!</h2>
    <mat-dialog-content>
        <p style="max-width: 500px;">Oops! It seems like you haven't granted permission to Creatics to
            access your Apple ID, which prevented the sign-in process. Please
            click 'Read More' for further instructions. We also offer sign-in
            options via Google, Facebook, or email. We apologize for the
            inconvenience.  <span style="cursor: pointer;color: #f44336;font-weight: 600;"
                (click)="onClickReadMore()">Read {{!readMore ? 'More' : 'less'}}</span>
            </p>
        <ol *ngIf="readMore" class="apple-help-desktop">
            <li>Visit the login page and click "Sign in with Apple."</li>
            <li>Enter your Apple ID credentials and sign in.</li>
            <li>If prompted, enter the verification code sent to your Apple
                device.</li>
            <li>Review the permissions and click "Allow" if requested.</li>
            <li>Congratulations! You are now signed in via Apple's SSO on
                your desktop browser.</li>
        </ol>
        <ol *ngIf="readMore" class="apple-help-mobile">
            <li>Visit the login page and click "Sign in with Apple."</li>
            <li>Select your Apple ID email.</li>
            <li>Authenticate using your Apple ID password or biometric
                verification (Touch ID/Face ID).</li>
            <li>Review the permissions and click "Allow" if requested.</li>
            <li>Congratulations! You are now signed in via Apple's SSO on
                your mobile browser.</li>
        </ol>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="warn" matDialogClose>Dismiss</button>
    </mat-dialog-actions>
</ng-template>
